import { InfoList } from "../types/infoLists";
import { Socials } from "../types/socials";
import DETAILS from "./about";

const ContactsLists: InfoList = {
    header: "CONTACTS",
    list: [
        {
            preLabel: "Email",
            label: DETAILS.email,
            link: `mailto:${DETAILS.email}`
        }
    ] as Socials[],
}

export default ContactsLists;